export const CLIENT_PROTECTION_TITLE = 'Client protection';

export const CLIENT_PROTECTION_SUBTITLE = 'Our commitment to your borrowers';

export const CLIENT_PROTECTION_EFFECTIVE_PREFIX = 'Effective';

export const CLIENT_PROTECTION_UPDATED_PREFIX = 'Last updated';

export const CLIENT_PROTECTION_REPORT_LABEL = 'Report a concern';

export const CLIENT_PROTECTION_REPORT_SUBJECT = 'Client protection concern';
